<div
  class="position-absolute start-0 top-0 bottom-0 end-0
    d-flex justify-content-center"
  [ngClass]="spinnerClasses"
>
  <div class="position-absolute start-0 top-0 bottom-0 end-0 bg-white opacity-50"></div>
  <div class="spinner-border text-primary spinner-grow-lg" role="status"></div>
</div>
